<hatch-overlay></hatch-overlay>

<div class="contentArea ">
  <section *ngIf="locale === 'en-us'" id="" class="productlist">
    <div class=" ">
      <div class="contentRow">

        <p class="pageheadtxt">Explore the range of high-performance products compatible with <a target="_blank"
            href="https://www.nvidia.com/en-us/design-visualization/creators/">NVIDIA Studio technology.</a> </p>
        <!-- Tabbing starts -->
        <div class="page_tab_container">
          <div class="page_tabs_wrapper">
            <ul class="page_tabs" (click)="clearLeftFilter()">
              <li id="nv_tb_1" [ngClass]="{ 'active_pane':activeTab==='Creative Dabbler'}"
                (click)="switchTab('Creative Dabbler')" data-tab="nv_tb_1"><b>Creative Dabbler</b></li>
              <li id="nv_tb_2" [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}"
                (click)="switchTab('Creative Maestro');" data-tab="nv_tb_2"><b>Creative Maestro</b></li>
              <li id="nv_tb_3" [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}"
                (click)="switchTab('Creative Powerhouse')" data-tab="nv_tb_3"><b>Creative Powerhouse</b></li>
              <!-- <li id="nv_tb_4" [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" (click)="switchTab('Enterprise Pro')" data-tab="nv_tb_4"><b>Enterprise Pro</b></li> -->
            </ul>
          </div>
          <div class="page_tabs_content">
            <div
              [ngClass]="{ 'active_pane':(activeTab!='Creative Maestro' && activeTab!='Creative Powerhouse' && activeTab!='Enterprise Pro')}"
              class="page_tabs_pane" id="nv_tb_1">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">
                    NVIDIA Studio badged products contain NVIDIA’s powerful RTX GPUs and are purpose-built and tested
                    specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-us/studio/products/"> Learn More ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Creative Dabbler</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Optimized for Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Edit video in up to 4K in real-time</span></li>
                      <li class="specList p-medium"><span>Work smarter with AI-accelerated features</span></li>
                      <li class="specList p-medium"><span>Razor thin designs optimized for high portability</span></li>
                      <li class="specList p-medium"><span>Animate small to medium 3D models</span></li>
                      <li class="specList p-medium"><span>1080p gaming and broadcasting</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">
                      Powerful NVIDIA Studio systems for demanding creators that need the best experience in graphic
                      design and photography, and want to dive into video editing.
                    </div>

                  </div>



                  <div class="bannerBtn">
                    <div class="bannerBtnGroup">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Creative Dabbler')" [disabled]="personaConActiveClick"
                        class="btn brand-green-btn" type="button">Apply Filters</button>
                      <!-- <div class="btn-label">Consumer</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'CreativeDabbler-enterprise')" [disabled]="personaEntActiveClick" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Enterprise</div>
                      </div> -->
                  </div>



                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}" class="page_tabs_pane " id="nv_tb_2">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful RTX GPUs and
                    are purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-us/studio/products/"> Learn More ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Creative Maestro</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Edit video in up to 6K in real-time</span></li>
                      <li class="specList p-medium"><span>Animate large 3D models with ray tracing</span></li>
                      <li class="specList p-medium"><span>Optimized for Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Up to 1440p gaming and broadcasting</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">NVIDIA Studio laptops and desktops are loaded with powerful NVIDIA
                      RTX GPUs, and precision-engineered for advanced creators who need next-level performance.</div>
                  </div>


                  <div class="bannerBtn" style="display: none;"><button (click)="changed($event,'Creative Maestro')"
                      id="id_Maestro" class="btn brand-green-btn" type="button">Apply Filters</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}" class="page_tabs_pane " id="nv_tb_3">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful RTX GPUs and
                    are purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-us/studio/products/"> Learn More ></a></div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Creative Powerhouse</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Edit video in up to 8K in real-time</span></li>
                      <li class="specList p-medium"><span>Animate massive 3D models with large memory sizes and
                          accelerated ray tracing</span></li>
                      <li class="specList p-medium"><span>Optimized for Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>4K gaming and broadcasting</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">State-of-the-art NVIDIA Studio systems powered by the world’s best <a
                        target="_blank" href="https://www.nvidia.com/en-us/geforce/20-series">NVIDIA RTX GPUs</a> for
                      creators seeking top-of-the-line technology to meet the most challenging creative needs.</div>
                  </div>


                  <div class="bannerBtn" style="display: none;"><button kuiButton [size]="'large'" [danger]="false"
                      [type]="'primary'" (click)="changed($event,'Creative Powerhouse')" id="id_Powerhouse"
                      class="btn brand-green-btn" type="button">Apply Filters</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" class="page_tabs_pane " id="nv_tb_4">
              <div class="page_tabs_banner">
                <div class="fullWidth">

                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful <a
                      target="_blank" href="https://www.nvidia.com/en-us/geforce/20-series/">RTX GPUs</a> and are
                    purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-us/studio/professional-workstations/"> Learn more ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Enterprise Pro</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Tackle the most advanced multi-app workflows</span></li>
                      <li class="specList p-medium"><span>100+ software application certifications</span></li>
                      <li class="specList p-medium"><span>Exclusive Quadro professional features like Quadro Sync,
                          NVIDIA Mosaic, GPUDirect for Video, and more</span></li>
                      <li class="specList p-medium"><span>Data center tested and certified</span></li>
                      <li class="specList p-medium"><span>Enterprise-level support</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">All the benefits of a Quadro NVIDIA Studio system plus
                      enterprise-grade technology like massive, scalable memory capacity, and multi-display technology.
                      Provides workstation-class reliability for professional creators who make creating their life's
                      work. <a target="_blank" href="https://www.nvidia.com/en-us/studio/professional-workstations/">
                        Learn more ></a></div>
                  </div>


                  <div class="bannerBtn">
                    <!-- <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"  class="btn brand-green-btn" type="button">Apply Filters</button> -->
                    <div class="bannerBtnGroup" style="display: none;">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Enterprise Pro')" id="id_EntPro" class="btn brand-green-btn"
                        type="button">Apply Filters</button>
                      <!-- <div class="btn-label">Mobile Workstations</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'DesktopWorkstations')" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Desktop Workstations</div>
                      </div> -->



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="locale === 'en-gb'" id="" class="productlist">
    <div class=" ">
      <div class="contentRow">
        <p class="pageheadtxt">Explore the range of high-performance products compatible with <a target="_blank"
            href="https://www.nvidia.com/en-gb/design-visualization/creators/">NVIDIA Studio technology.</a> </p>
        <!-- Tabbing starts -->
        <div class="page_tab_container">
          <div class="page_tabs_wrapper">
            <ul class="page_tabs" (click)="clearLeftFilter()">
              <li id="nv_tb_1" [ngClass]="{ 'active_pane':activeTab==='Creative Dabbler'}"
                (click)="switchTab('Creative Dabbler')" data-tab="nv_tb_1"><b>Creative Dabbler</b></li>
              <li id="nv_tb_2" [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}"
                (click)="switchTab('Creative Maestro')" class="" data-tab="nv_tb_2"><b>Creative Maestro</b></li>
              <li id="nv_tb_3" [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}"
                (click)="switchTab('Creative Powerhouse')" class="" data-tab="nv_tb_3"><b>Creative Powerhouse</b></li>
              <!-- <li id="nv_tb_4"  [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}"  (click)="switchTab('Enterprise Pro')"class="" data-tab="nv_tb_4"><b>Enterprise Pro</b></li> -->
            </ul>
          </div>
          <div class="page_tabs_content">
            <div
              [ngClass]="{ 'active_pane':(activeTab!='Creative Maestro' && activeTab!='Creative Powerhouse' && activeTab!='Enterprise Pro')}"
              class="page_tabs_pane" id="nv_tb_1">
              <div
                [ngClass]="{ 'active_pane':(activeTab!='Creative Maestro' && activeTab!='Creative Powerhouse' && activeTab!='Enterprise Pro')}"
                class="page_tabs_pane" id="nv_tb_1">
                <div class="page_tabs_banner">
                  <div class="fullWidth">
                    <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                        title=""> </div>
                    <div class="infoText p-medium">
                      NVIDIA Studio badged products contain NVIDIA’s powerful RTX GPUs and are purpose-built and tested
                      specifically for demanding creators.<a target="_blank"
                        href="https://www.nvidia.com/en-gb/studio/products/"> Learn More ></a>
                    </div>
                  </div>

                  <div class="fullWithpadding paddingNone">
                    <h3 class="color-green">Creative Dabbler</h3>
                    <div class="page_tabs_col">
                      <ul class="brandSpecs">
                        <li class="specList p-medium"><span>Optimized for Adobe Creative Cloud</span></li>
                        <li class="specList p-medium"><span>Edit video in up to 4K in real-time</span></li>
                        <li class="specList p-medium"><span>Work smarter with AI-accelerated features</span></li>
                        <li class="specList p-medium"><span>Razor thin designs optimized for high portability</span>
                        </li>
                        <li class="specList p-medium"><span>Animate small to medium 3D models</span></li>
                        <li class="specList p-medium"><span>1080p gaming and broadcasting</span></li>
                      </ul>
                    </div>
                    <div class="page_tabs_col">
                      <div class="infoText p-medium">
                        Powerful NVIDIA Studio systems for demanding creators that need the best experience in graphic
                        design and photography, and want to dive into video editing.
                      </div>

                    </div>



                    <div class="bannerBtn">
                      <div class="bannerBtnGroup">
                        <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                          (click)="changed($event,'Creative Dabbler')" [disabled]="personaConActiveClick"
                          class="btn brand-green-btn" type="button">Apply Filters</button>
                        <!-- <div class="btn-label">Consumer</div> -->
                      </div>
                      <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'CreativeDabbler-enterprise')" [disabled]="personaEntActiveClick" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Enterprise</div>
                      </div> -->
                    </div>



                  </div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}" class="page_tabs_pane " id="nv_tb_2">
              <div class="page_tabs_banner">
                <div class="fullWidth">

                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful RTX GPUs and
                    are purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-gb/studio/products/"> Learn More ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Creative Maestro</h3>

                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Edit video in up to 6K in real-time</span></li>
                      <li class="specList p-medium"><span>Animate large 3D models with ray tracing</span></li>
                      <li class="specList p-medium"><span>Optimised for Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Up to 1440p gaming and broadcasting</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">NVIDIA Studio laptops and desktops are loaded with powerful NVIDIA
                      RTX GPUs, and precision-engineered for advanced creators who need next-level performance.</div>
                  </div>

                  <div class="bannerBtn" style="display: none;"><button (click)="changed($event,'Creative Maestro')"
                      id="id_Maestro" class="btn brand-green-btn" type="button">Apply Filters</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}" class="page_tabs_pane " id="nv_tb_3">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful RTX GPUs and
                    are purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-gb/studio/products/"> Learn More ></a></div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Creative Powerhouse</h3>

                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Edit video in up to 8K in real-time</span></li>
                      <li class="specList p-medium"><span>Animate massive 3D models with large memory sizes and
                          accelerated ray tracing</span></li>
                      <li class="specList p-medium"><span>Optimised for Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>4K gaming and broadcasting</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">State-of-the-art NVIDIA Studio systems powered by the world’s best <a
                        target="_blank" href="https://www.nvidia.com/en-gb/geforce/20-series">NVIDIA RTX GPUs</a> for
                      creators seeking top-of-the-line technology to meet the most challenging creative needs.</div>
                  </div>
                  <div class="bannerBtn" style="display: none;"><button (click)="changed($event,'Creative Powerhouse')"
                      id="id_Powerhouse" class="btn brand-green-btn" type="button">Apply Filters</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" class="page_tabs_pane hide"
              style="display: none;" id="nv_tb_4">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful <a
                      target="_blank" href="https://www.nvidia.com/en-gb/geforce/20-series/">RTX GPUs</a> and are
                    purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-gb/studio/products/"> Learn more ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Enterprise Pro</h3>

                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Tackle the most advanced multi-app workflows</span></li>
                      <li class="specList p-medium"><span>100+ software application certifications</span></li>
                      <li class="specList p-medium"><span>Exclusive Quadro professional features like Quadro Sync,
                          NVIDIA Mosaic, GPUDirect for Video, and more</span></li>
                      <li class="specList p-medium"><span>Data centre tested and certified</span></li>
                      <li class="specList p-medium"><span>Enterprise-level support</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">All the benefits of a Quadro NVIDIA Studio system plus
                      enterprise-grade technology like massive, scalable memory capacity, and multi-display technology.
                      Provides workstation-class reliability for professional creators who make creating their life's
                      work. <a target="_blank" href="https://www.nvidia.com/en-gb/studio/professional-workstations/">
                        Learn more ></a></div>
                  </div>
                  <div class="bannerBtn">
                    <!-- <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"  class="btn brand-green-btn" type="button">Apply Filters</button> -->
                    <div class="bannerBtnGroup" style="display: none;">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Enterprise Pro')" id="id_EntPro" class="btn brand-green-btn"
                        type="button">Apply Filters</button>
                      <!-- <div class="btn-label">Mobile Workstations</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'DesktopWorkstations')" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Desktop Workstations</div>
                      </div> -->



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>



  <section *ngIf="locale === 'fr-fr'" id="" class="productlist">
    <div class=" ">
      <div class="contentRow">

        <!-- <h2 class="pageheading"></h2> -->
        <p class="pageheadtxt">Découvrez notre gamme de produits à hautes performances compatibles avec la technologie
          <a target="_blank" href="https://www.nvidia.com/fr-fr/design-visualization/creators/">NVIDIA Studio.</a> </p>
        <!-- Tabbing starts -->
        <div class="page_tab_container">
          <div class="page_tabs_wrapper">
            <ul class="page_tabs" (click)="clearLeftFilter()">
              <li id="nv_tb_1" [ngClass]="{ 'active_pane':activeTab==='Creative Dabbler'}"
                (click)="switchTab('Creative Dabbler')" data-tab="nv_tb_1"><b>Série amateur</b></li>
              <li id="nv_tb_2" [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}"
                (click)="switchTab('Creative Maestro');" data-tab="nv_tb_2"><b>Série Maestro</b></li>
              <li id="nv_tb_3" [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}"
                (click)="switchTab('Creative Powerhouse')" data-tab="nv_tb_3"><b>Série Ultime</b></li>
              <!-- <li id="nv_tb_4" [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" (click)="switchTab('Enterprise Pro')" data-tab="nv_tb_4"><b>Enterprise Pro</b></li> -->
            </ul>
          </div>
          <div class="page_tabs_content">
            <div
              [ngClass]="{ 'active_pane':(activeTab!='Creative Maestro' && activeTab!='Creative Powerhouse' && activeTab!='Enterprise Pro')}"
              class="page_tabs_pane" id="nv_tb_1">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">
                    Dotés d’un logo exclusif et de GPU NVIDIA RTX aux performances de pointe, les produits NVIDIA Studio
                    ont été spécifiquement conçus et testés pour les créateurs les plus exigeants.<a target="_blank"
                      href="https://www.nvidia.com/fr-fr/studio/products/"> En savoir plus ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Série amateur</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Optimisation pour Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Éditez des vidéos jusqu’en résolution 4K en temps réel</span>
                      </li>
                      <li class="specList p-medium"><span>Travaillez plus intelligemment avec des fonctionnalités
                          accélérées par l’IA</span></li>
                      <li class="specList p-medium"><span>Systèmes à faible encombrement optimisés pour fournir une
                          portabilité et des performances élevées</span></li>
                      <li class="specList p-medium"><span>Animez des modèles 3D de taille compacte à moyenne </span>
                      </li>
                      <li class="specList p-medium"><span>Gaming et diffusion en 1080p </span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">
                      Systèmes NVIDIA Studio à la pointe de la technologie pour les amateurs de création numérique qui
                      exigent une expérience de la plus haute qualité pour la conception graphique, la retouche photo et
                      le montage vidéo.
                    </div>

                  </div>



                  <div class="bannerBtn">
                    <div class="bannerBtnGroup">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Creative Dabbler')" [disabled]="personaConActiveClick"
                        class="btn brand-green-btn" type="button">Appliquer Filtres</button>
                      <!-- <div class="btn-label">Consumer</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'CreativeDabbler-enterprise')" [disabled]="personaEntActiveClick" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Enterprise</div>
                      </div> -->
                  </div>



                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}" class="page_tabs_pane " id="nv_tb_2">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">Dotés d’un logo exclusif et de GPU NVIDIA RTX aux performances de
                    pointe, les produits NVIDIA Studio ont été spécifiquement conçus et testés pour les créateurs les
                    plus exigeants.<a target="_blank" href="https://www.nvidia.com/fr-fr/studio/products/"> En savoir
                      plus ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Série Maestro</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Éditez des vidéos jusqu’en résolution 6K en temps réel</span>
                      </li>
                      <li class="specList p-medium"><span>Animez des modèles 3D complexes grâce au ray tracing</span>
                      </li>
                      <li class="specList p-medium"><span>Optimisation pour Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Gaming et diffusion jusqu’en 1440p</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">Les PC portables et les PC de bureau NVIDIA Studio, qui embarquent de
                      puissants GPU NVIDIA RTX, ont été spécialement conçus pour les passionnés de création qui exigent
                      le plus haut niveau de performance. </div>
                  </div>


                  <div class="bannerBtn" style="display: none;"><button (click)="changed($event,'Creative Maestro')"
                      id="id_Maestro" class="btn brand-green-btn" type="button">Appliquer Filtres</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}" class="page_tabs_pane " id="nv_tb_3">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">Dotés d’un logo exclusif et de GPU NVIDIA RTX aux performances de
                    pointe, les produits NVIDIA Studio ont été spécifiquement conçus et testés pour les créateurs les
                    plus exigeants.<a target="_blank" href="https://www.nvidia.com/fr-fr/studio/products/"> En savoir
                      plus ></a></div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Série Ultime</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Éditez des vidéos jusqu’en résolution 8K en temps réel</span>
                      </li>
                      <li class="specList p-medium"><span>Animez des modèles 3D complexes grâce à 48 Go de mémoire
                          dédiée et au ray tracing accéléré par GPU</span></li>
                      <li class="specList p-medium"><span>Optimisation pour Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Gaming et diffusion en 4K</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">Basés sur les GPU NVIDIA RTX les plus puissants au monde, ces
                      systèmes NVIDIA Studio à la pointe de la technologie fournissent aux créateurs du monde entier des
                      technologies avancées pour couvrir l’ensemble de leurs besoins créatifs. </div>
                  </div>


                  <div class="bannerBtn" style="display: none;"><button kuiButton [size]="'large'" [danger]="false"
                      [type]="'primary'" (click)="changed($event,'Creative Powerhouse')" id="id_Powerhouse"
                      class="btn brand-green-btn" type="button">Apply Filters</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" class="page_tabs_pane " id="nv_tb_4">
              <div class="page_tabs_banner">
                <div class="fullWidth">

                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful <a
                      target="_blank" href="https://www.nvidia.com/en-us/geforce/20-series/">RTX GPUs</a> and are
                    purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-us/studio/professional-workstations/"> Learn more ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Entreprise Pro</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Tackle the most advanced multi-app workflows</span></li>
                      <li class="specList p-medium"><span>100+ software application certifications</span></li>
                      <li class="specList p-medium"><span>Exclusive Quadro professional features like Quadro Sync,
                          NVIDIA Mosaic, GPUDirect for Video, and more</span></li>
                      <li class="specList p-medium"><span>Data center tested and certified</span></li>
                      <li class="specList p-medium"><span>Enterprise-level support</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">All the benefits of a Quadro NVIDIA Studio system plus
                      enterprise-grade technology like massive, scalable memory capacity, and multi-display technology.
                      Provides workstation-class reliability for professional creators who make creating their life's
                      work. <a target="_blank" href="https://www.nvidia.com/en-us/studio/professional-workstations/">
                        Learn more ></a></div>
                  </div>


                  <div class="bannerBtn">
                    <!-- <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"  class="btn brand-green-btn" type="button">Apply Filters</button> -->
                    <div class="bannerBtnGroup" style="display: none;">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Enterprise Pro')" id="id_EntPro" class="btn brand-green-btn"
                        type="button">Appliquer des FILTRES</button>
                      <!-- <div class="btn-label">Mobile Workstations</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'DesktopWorkstations')" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Desktop Workstations</div>
                      </div> -->



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="locale === 'de-de'" id="" class="productlist">
    <div class=" ">
      <div class="contentRow">

        <!-- <h2 class="pageheading"></h2> -->
        <p class="pageheadtxt">Entdecke die leistungsstarken Produkte, die mit der <a target="_blank"
            href="https://www.nvidia.com/de-de/studio/">NVIDIA Studio-Technologie</a> kompatibel sind.</p>
        <!-- Tabbing starts -->
        <div class="page_tab_container">
          <div class="page_tabs_wrapper">
            <ul class="page_tabs" (click)="clearLeftFilter()">
              <li id="nv_tb_1" [ngClass]="{ 'active_pane':activeTab==='Creative Dabbler'}"
                (click)="switchTab('Creative Dabbler')" data-tab="nv_tb_1"><b>Kreativneuling</b></li>
              <li id="nv_tb_2" [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}"
                (click)="switchTab('Creative Maestro');" data-tab="nv_tb_2"><b>Kreativmeister</b></li>
              <li id="nv_tb_3" [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}"
                (click)="switchTab('Creative Powerhouse')" data-tab="nv_tb_3"><b>Kreatives Kraftpaket</b></li>
              <!-- <li id="nv_tb_4" [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" (click)="switchTab('Enterprise Pro')" data-tab="nv_tb_4"><b>Enterprise Pro</b></li> -->
            </ul>
          </div>
          <div class="page_tabs_content">
            <div
              [ngClass]="{ 'active_pane':(activeTab!='Creative Maestro' && activeTab!='Creative Powerhouse' && activeTab!='Enterprise Pro')}"
              class="page_tabs_pane" id="nv_tb_1">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">
                    Produkte mit NVIDIA Studio enthalten die leistungsstarken RTX-Grafikprozessoren von NVIDIA und
                    wurden speziell für anspruchsvolle Anwender entwickelt und getestet.<a target="_blank"
                      href="https://www.nvidia.com/de-de/studio/laptops-desktops/"> Mehr erfahren ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Kreativneuling</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Optimiert für Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Bearbeite Videos in Echtzeit mit bis zu 4K</span></li>
                      <li class="specList p-medium"><span>Intelligenter arbeiten mit KI-beschleunigten Funktionen</span>
                      </li>
                      <li class="specList p-medium"><span>Extrem schlanke Designs, optimiert für hohe
                          Portabilität</span></li>
                      <li class="specList p-medium"><span>Animiere kleine bis mittelgroße 3D-Modelle </span></li>
                      <li class="specList p-medium"><span>Spielen und Streamen mit 1080p</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">
                      Leistungsstarke NVIDIA Studio-Systeme für anspruchsvolle Creators, die die beste Erfahrung bei
                      Grafikdesign und Fotografie benötigen und in die Videobearbeitung eintauchen möchten.
                    </div>

                  </div>



                  <div class="bannerBtn">
                    <div class="bannerBtnGroup">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Creative Dabbler')" [disabled]="personaConActiveClick"
                        class="btn brand-green-btn" type="button">Filter Anwenden</button>
                      <!-- <div class="btn-label">Consumer</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'CreativeDabbler-enterprise')" [disabled]="personaEntActiveClick" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Enterprise</div>
                      </div> -->
                  </div>



                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Maestro'}" class="page_tabs_pane " id="nv_tb_2">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src="https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">Produkte mit NVIDIA Studio enthalten die leistungsstarken
                    RTX-Grafikprozessoren von NVIDIA und wurden speziell für anspruchsvolle Anwender entwickelt und
                    getestet.<a target="_blank" href="https://www.nvidia.com/de-de/studio/laptops-desktops/"> Mehr
                      erfahren ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Kreativmeister</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Bearbeite in Echtzeit Videos in Auflösungen bis zu 6K</span>
                      </li>
                      <li class="specList p-medium"><span>Animiere große 3D-Modelle mit Raytracing</span></li>
                      <li class="specList p-medium"><span>Optimiert für Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Spielen und Streamen mit bis zu 1440p</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">NVIDIA Studio-Laptops und -Desktops sind mit leistungsstarken NVIDIA
                      RTX-Grafikprozessoren ausgestattet und wurden speziell für fortgeschrittene Anwender entwickelt,
                      die Leistung auf höchstem Niveau benötigen.</div>
                  </div>


                  <div class="bannerBtn" style="display: none;"><button (click)="changed($event,'Creative Maestro')"
                      id="id_Maestro" class="btn brand-green-btn" type="button">Filter Anwenden</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Creative Powerhouse'}" class="page_tabs_pane " id="nv_tb_3">
              <div class="page_tabs_banner">
                <div class="fullWidth">
                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">Produkte mit NVIDIA Studio enthalten die leistungsstarken
                    RTX-Grafikprozessoren von NVIDIA und wurden speziell für anspruchsvolle Anwender entwickelt und
                    getestet.<a target="_blank" href="https://www.nvidia.com/de-de/studio/laptops-desktops/"> Mehr
                      erfahren ></a></div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Kreatives Kraftpaket</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Bearbeite in Echtzeit Videos in Auflösungen bis zu 8K</span>
                      </li>
                      <li class="specList p-medium"><span>Animiere riesige 3D-Modelle mit bis zu 48 GB Arbeitsspeicher
                          und beschleunigtem Raytracing</span></li>
                      <li class="specList p-medium"><span>Optimiert für Adobe Creative Cloud</span></li>
                      <li class="specList p-medium"><span>Spielen und Streamen in 4K</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">Hochmoderne NVIDIA Studio-Systeme mit den weltbesten <a
                        target="_blank" href="https://www.nvidia.com/de-de/geforce/20-series">NVIDIA
                        RTX-Grafikprozessoren</a> für Creators, die Spitzentechnologie für die anspruchsvollsten
                      kreativen Anforderungen suchen.</div>
                  </div>


                  <div class="bannerBtn" style="display: none;"><button kuiButton [size]="'large'" [danger]="false"
                      [type]="'primary'" (click)="changed($event,'Creative Powerhouse')" id="id_Powerhouse"
                      class="btn brand-green-btn" type="button">Filter Anwenden</button></div>
                </div>
              </div>
            </div>
            <div [ngClass]="{ 'active_pane':activeTab==='Enterprise Pro'}" class="page_tabs_pane " id="nv_tb_4">
              <div class="page_tabs_banner">
                <div class="fullWidth">

                  <div class="logo_icon"><img src=" https://assets.nvidia.partners/studio/nvidia-studio.png" alt=""
                      title=""> </div>
                  <div class="infoText p-medium">NVIDIA Studio badged products contain NVIDIA’s powerful <a
                      target="_blank" href="https://www.nvidia.com/en-us/geforce/20-series/">RTX GPUs</a> and are
                    purpose-built and tested specifically for demanding creators.<a target="_blank"
                      href="https://www.nvidia.com/en-us/studio/professional-workstations/"> Learn more ></a>
                  </div>
                </div>

                <div class="fullWithpadding paddingNone">
                  <h3 class="color-green">Enterprise Pro</h3>
                  <div class="page_tabs_col">
                    <ul class="brandSpecs">
                      <li class="specList p-medium"><span>Tackle the most advanced multi-app workflows</span></li>
                      <li class="specList p-medium"><span>100+ software application certifications</span></li>
                      <li class="specList p-medium"><span>Exclusive Quadro professional features like Quadro Sync,
                          NVIDIA Mosaic, GPUDirect for Video, and more</span></li>
                      <li class="specList p-medium"><span>Data center tested and certified</span></li>
                      <li class="specList p-medium"><span>Enterprise-level support</span></li>
                    </ul>
                  </div>
                  <div class="page_tabs_col">
                    <div class="infoText p-medium">All the benefits of a Quadro NVIDIA Studio system plus
                      enterprise-grade technology like massive, scalable memory capacity, and multi-display technology.
                      Provides workstation-class reliability for professional creators who make creating their life's
                      work. <a target="_blank" href="https://www.nvidia.com/en-us/studio/professional-workstations/">
                        Learn more ></a></div>
                  </div>


                  <div class="bannerBtn">
                    <!-- <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"  class="btn brand-green-btn" type="button">Apply Filters</button> -->
                    <div class="bannerBtnGroup" style="display: none;">
                      <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
                        (click)="changed($event,'Enterprise Pro')" id="id_EntPro" class="btn brand-green-btn"
                        type="button">Apply Filters</button>
                      <!-- <div class="btn-label">Mobile Workstations</div> -->
                    </div>
                    <!-- <div class="bannerBtnGroup">
                          <button kuiButton [size]="'large'" [danger]="false" [type]="'primary'" (click)="changed($event,'DesktopWorkstations')" class="btn brand-green-btn" type="button" >Apply Filters</button>
                          <div class="btn-label">Desktop Workstations</div>
                      </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>